import { useContext } from 'react'

import { ToastContext } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import useSizingWidgetConfiguration from './hooks/useSizingWidgetConfiguration/useSizingWidgetConfiguration'
import SizingWidgetConfiguration from './SizingWidgetConfiguration/SizingWidgetConfiguration'
import SizingWidgetConfigurationPageSkeleton from './SizingWidgetConfigurationPageSkeleton/SizingWidgetConfigurationPageSkeleton'
import * as Styles from './styles'

const SizingWidgetConfigurationPage = () => {
  const { info } = useContext(AppContext)
  const { hasPermission } = useUserPermissions()
  const { setToastInfo } = useContext(ToastContext)
  const supportedLanguages = info?.selectedStore?.supported_languages || ['en']

  const {
    backgroundColor,
    setBackgroundColor,
    textColor,
    setTextColor,
    fetchingSizingWidgetPreferences,
    hasChanges,
    useCustomTextTooBig,
    setUseCustomTextTooBig,
    setCustomTextTooBig,
    customTextTooBig,
    useCustomTextTooSmall,
    setUseCustomTextTooSmall,
    customTextTooSmall,
    setCustomTextTooSmall,
    scriptExample,
    onSave,
    editing,
    revertChanges,
    productTaxonomyDisplay,
    setProductTaxonomyDisplay,
    productTaxonomyIds,
    setProductTaxonomyIds,
    productCategories,
  } = useSizingWidgetConfiguration({
    storeId: info.selectedStore.id,
    setToastInfo,
    supportedLanguages,
  })

  if (fetchingSizingWidgetPreferences) {
    return <SizingWidgetConfigurationPageSkeleton />
  }

  return (
    <Styles.Container>
      {hasChanges && <UnsavedChangesAlert hasPermission={hasPermission(userPermissions.editExtra)} />}
      <SizingWidgetConfiguration
        supportedLanguages={supportedLanguages}
        backgroundColor={backgroundColor}
        setBackgroundColor={setBackgroundColor}
        textColor={textColor}
        setTextColor={setTextColor}
        useCustomTextTooBig={useCustomTextTooBig}
        setUseCustomTextTooBig={setUseCustomTextTooBig}
        customTextTooBig={customTextTooBig}
        setCustomTextTooBig={setCustomTextTooBig}
        useCustomTextTooSmall={useCustomTextTooSmall}
        setUseCustomTextTooSmall={setUseCustomTextTooSmall}
        customTextTooSmall={customTextTooSmall}
        setCustomTextTooSmall={setCustomTextTooSmall}
        productTaxonomyDisplay={productTaxonomyDisplay}
        setProductTaxonomyDisplay={setProductTaxonomyDisplay}
        productTaxonomyIds={productTaxonomyIds}
        setProductTaxonomyIds={setProductTaxonomyIds}
        productCategories={productCategories}
        scriptExample={scriptExample}
      />
      <SaveChangesButtons
        hasChanges={hasPermission(userPermissions.editExtra) && hasChanges}
        onSave={onSave}
        onRevertChanges={revertChanges}
        loading={editing}
        disabled={editing}
      />
    </Styles.Container>
  )
}

export default SizingWidgetConfigurationPage
